"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorMessageService = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ErrorMessageService =
/*#__PURE__*/
function () {
  function ErrorMessageService() {
    _classCallCheck(this, ErrorMessageService);

    this.errorMessages = {
      'user_name_password_login_error': 'The Username or Password you entered is not correct. Please try again.',
      'standard_page_level_error': 'Please correct or complete the highlighted areas below.',
      'page_unable_to_load_header_error': 'Please try again',
      'page_unable_to_load_text_error': 'An error occurred while accessing this site. Try refreshing the page.',
      'yes_no_toggle_error': 'Select Yes or No.',
      'no_selection_error': 'Select one.',
      'last_name_error': 'Last Name must contain at least 2 characters and can only contain letters, numbers, hyphens, commas, apostrophes, and periods.',
      'first_name_error': 'First Name must contain at least 2 characters and can only contain letters, numbers, hyphens, commas, apostrophes, and periods.',
      'taxpayer_identification_dob_error': 'Taxpayer Identification Number must be 9 digits.',
      'social_security_dob_error': 'Social Security Number must be 9 digits.',
      'dob_dob_error': 'SSN/TIN must be 9 digits.',
      'symbol_cusip_error': 'Enter a valid symbol or CUSIP.',
      'fund_name_symbol_error': 'Enter a valid fund name or symbol.',
      'dob_error': 'Enter a valid Date of Birth.',
      'dob_no_month_selected_error': 'Select Month.',
      'dob_no_day_entered_error': 'Enter date.',
      'dob_no_year_entered_error': 'Enter year.',
      'dob_no_year_selected_error': 'Select year.',
      'phone_number_error': 'Phone Number must be 10 digits.',
      'email_error': 'Enter a valid Email (e.g., yourinfo@example.com).',
      'address_left_blank_error': 'Enter Address.',
      'address_no_po_accepted_error': 'Address cannot be a PO Box.',
      'address_contains_bad_symbol_error': 'Address can\'t have symbols, e.g., %, ?, @, or +.',
      'city_left_blank_error': 'Enter City.',
      'province_left_blank_error': 'Enter Province.',
      'state_not_selected_error': 'Select State.',
      'zip_code_invalid_error': 'Enter valid 5-digit ZIP Code.',
      'zip_plus_4_invalid_error': 'Enter valid ZIP+4.',
      'postal_code_error': 'Enter valid Postal Code.',
      'country_not_selected_error': 'Select Country.',
      'account_number_invalid_error': 'Account number must be a combination of 9 letters and numbers.',
      'contract_number_invalid_error': 'Contract Number must be 8 digits.',
      'country_citizenship_error': 'Select Country of Citizenship.',
      'country_tax_residency_error': 'Select Country of Tax Residency.',
      'government_issued_id_error': 'Select Form of Government-Issued ID.',
      'id_number_error': 'Enter valid ID Number.',
      'us_residence_status_error': 'Select U.S. Residence Status.',
      'employment_status_error': 'Select Employment Status.',
      'occupation_error': 'Enter Occupation.',
      'employer_name_error': 'Enter Employer Name.',
      'employer_entity_name_error': 'Enter Employer/Entity Name.',
      'company_name_error': 'Enter Company Name.',
      'value_error': 'Enter an amount between $.01 and $9,999,999.99.',
      'negative_amount_value_error': 'Enter an amount between -$999,999.99 and +$9,999,999.99.',
      'percent_error': 'Percent value must be a whole number between 1 and 100.',
      'total_percent_not_100_error': 'Total Percentage Assigned must equal 100%.',
      'select_account_error': 'Select Account Type.',
      'number_of_dependents_error': 'Enter the Number of Dependents.',
      'terms_and_conditions_checkbox_error': 'You must agree to the Terms and Conditions to continue.',
      'bank_name_error': 'Enter the Bank Name.',
      'federal_taxes_selection_error': 'Choose how you would like to have federal taxes withheld.'
    };
  }

  _createClass(ErrorMessageService, [{
    key: "getErrorMessage",
    value: function getErrorMessage(name) {
      if (this.errorMessages[name.toLowerCase()] === undefined) {
        throw 'Error: error name passed in is not defined in Fidelity error messages list, please check if there\'s a typo in the error name';
      } else {
        return this.errorMessages[name.toLowerCase()];
      }
    }
  }]);

  return ErrorMessageService;
}();

exports.ErrorMessageService = ErrorMessageService;